import axios from 'axios'
import { api_pessoas } from 'services/apis'
import {
  GetDadosIntegracaoBoletoResponse,
  PostConsultaServicoResponse,
  PostGravaAdesaoAPI,
  PostGravaAdesaoAPIResponse,
  PostRegistraBoletoParams,
  GetConsultarAdesaoAPIResponse,
} from 'types/gravaAdesaoAPI'

export const postGravaPropostaIntegracao = async ({ guid }: PostGravaAdesaoAPI) => {
  const URL = `/pessoas/${guid}/grava-proposta-integracao`
  const response = await api_pessoas.post<PostGravaAdesaoAPIResponse>(URL)
  return response.data
}

export const getConsultarPropostaIntegracao = async ({ guid }: PostGravaAdesaoAPI) => {
  const URL = `/pessoas/${guid}/consultar-proposta-integracao`
  const response = await api_pessoas.get<GetConsultarAdesaoAPIResponse>(URL)
  return response.data.data
}

export const postConsultaServicoIntegracao = async () => {
  const cd_servico = 'BB006'
  const URL = `/pessoas/consulta-servico/${cd_servico}`
  const response = await api_pessoas.post<PostConsultaServicoResponse>(URL)
  return response.data.data.sn_ativo
}

export const getDadosIntegracaoBoleto = async ({ idConcc030 }: { idConcc030: number }) => {
  const URL = `/pessoas/dados-integracao-boleto/${idConcc030}`
  const response = await api_pessoas.get<GetDadosIntegracaoBoletoResponse>(URL)
  return response.data.data
}

export const postRegistraBoleto = async (params: PostRegistraBoletoParams) => {
  const {
    idconv,
    reftran,
    valor,
    dtvenc,
    tppagamento,
    cpfcnpj,
    indicadorpessoa,
    tpduplicata,
    urlretorno,
    nome,
    endereco,
    cidade,
    uf,
    cep
  } = params

  const URL = 'https://mpag.bb.com.br/site/mpag/'
  const queryString = `?idConv=${idconv}&refTran=${reftran}&valor=${valor}&dtVenc=${dtvenc}&tpPagamento=${tppagamento}&cpfCnpj=${cpfcnpj}&indicadorPessoa=${indicadorpessoa}&tpDuplicata=${tpduplicata}&urlRetorno=${urlretorno}&nome=${nome}&endereco=${endereco}&cidade=${cidade}&uf=${uf}&cep=${cep}`

  const response = await axios.post(URL + queryString)
  return response.data.data
}
